import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { Text, Link, ChevronDownIcon } from '@pancakeswap-libs/uikit'
import Logo from 'components/Logo'
import useI18n from 'hooks/useI18n';
import SearchModal from './SearchModal'
import { SelectItem } from './ItemInter'

const OptionSelect = styled.button<{ selected: boolean }>`
    display: flex;
    width: 100%;
    align-items: center;
    font-weight: 500;
    background-color: transparent;
		color: ${(props) => props.theme.colors.primary};
    border-radius: 12px;
    outline: none;
    cursor: pointer;
    user-select: none;
    border: none;
    padding: 8px 16px;
		background-color: ${(props) => props.theme.colors.input};
		border-radius: ${(props) => props.theme.radii.default};`

const OptionImage = styled(Logo)`
  height: 24px;
  width: auto;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  vertical-align: middle;
  margin-right: 10px;
`

const Label = styled(Text)`
	overflow: hidden;
	flex: 1;
    text-align: left;
    height: 56px;
    line-height: 56px;
    font-size: 18px;
`

interface SelectCurrencyProps {
	onSelect: (option: SelectItem) => void
	selected?: any
	options: any
}

export default function ({ selected, onSelect, options }: SelectCurrencyProps) {
	const [option, setOption] = useState<SelectItem>(selected);
	const [modalOpen, setModalOpen] = useState(false)
	const TranslateString = useI18n();


	const handleChange = (value) => {
		setOption(value);
		setModalOpen(false)
		onSelect(value)
	};

	useEffect(()=>{
		if(selected!==undefined){
			setOption(selected);
			if (selected?.id?.toLowerCase()!==option?.id?.toLowerCase()) {
				setModalOpen(false)
				onSelect(selected);
			}
		}
	},
	// eslint-disable-next-line
	[selected])

	return (
		<>
			<OptionSelect
				selected={!!option?.id}
				className="open-currency-select-button"
				onClick={() => setModalOpen(true)}
			>

				{/* add text id */}
				{option?.textId?
				<>
					{option?.id && <OptionImage srcs={[option.image, "/images/UNKNOWNSEP20.png"]} alt={`${TranslateString(option.textId,option?.name)} Logo`} />}
					<Label color={option?.id ? "text" : "rgb(132 131 131)"} title={TranslateString(option.textId,option?.name)}>
						{option?.name?TranslateString(option.textId,option?.name):TranslateString(1388, "Select an Option")}
					</Label>
				</>
				 :
				 <>
					{option?.id && <OptionImage srcs={[option.image, "/images/UNKNOWNSEP20.png"]} alt={`${option?.name} Logo`} />}
					<Label color={option?.id ? "text" : "rgb(132 131 131)"} title={option?.name}>
						{option?.name || TranslateString(1388, "Select an Option")}
					</Label>
				 </>
				}

				<ChevronDownIcon color='rgb(132 131 131)'/>
			</OptionSelect>
			<SearchModal
				isOpen={modalOpen}
				onDismiss={() => setModalOpen(false)}
				onSelect={handleChange}
				options={options}
			/>
		</>
	)
}